// extracted by mini-css-extract-plugin
export default {"checkoutContainer":"CheckoutContainer_checkoutContainer__xKBJN"};